import React from 'react'; 
import './Prayers.css';

import { Heading } from '../../../components';
import { prayers } from '../../../constants';



const Prayers = () => {    
  return (
    <section className='prayer-timing linear-bg'>

      <Heading title={'Prayer Timings'} subTitle={'Daily Salah Schedule'} linear />

      {/* Container for all prayer items */}
      <div className='box-container'>
      {
        // Mapping through all prayers from constants
        prayers.map((prayer) => {
          return( 
          <div className='prayer-item' key={prayer.id}>

            {/* Prayer name (e.g., Fajr, Dhuhr, Asr, etc.) */}
            <h4>{prayer.name}</h4>

            {/* Prayer timing details */}
            <ul className='content'>

              {/* Start time of the prayer */}
              <li><h6>start:</h6><span>{prayer.start}</span></li>

              {/* Conditionally render iqamah time only if it exists */}
              {prayer.iqamah.length > 0 && (
                <li><h6>iqamah:</h6><span>{prayer.iqamah}</span></li>
              )}

            </ul>
          </div>
          )
        })
        }
        </div>

    </section>
  )
}

export default Prayers;